import { combineReducers } from 'redux'
import login from './login'
import paymentReducer from './paymentReducer'
import eventDetailsReducer from './eventDetailsReducer'

export default combineReducers({
	login,
	paymentReducer,
	eventDetailsReducer
})
